import Axios from 'axios';
// Showdebuginfo
Axios.interceptors.response.use(response => {

  if (window.location.search.indexOf('..showdebuginfo..=on') !== -1
		&& response.headers['content-type'] === 'application/json; charset=utf-8') {

    const o = null;
    // eslint-disable-next-line
		eval("o = " + response.data);

    response.data = o;

    return response;
  }

  return response;

}, error => {
  return Promise.reject(error);
});

export default {
  install(Vue) {
    if (!Axios) {

      throw Error('NPM install Axios');
    }

    Vue.prototype.$http = Axios;
  },
  Axios
};
